import { render, staticRenderFns } from "./exercisesCT.vue?vue&type=template&id=00f9e052"
import script from "./exercisesCT.vue?vue&type=script&lang=js"
export * from "./exercisesCT.vue?vue&type=script&lang=js"
import style0 from "./exercisesCT.vue?vue&type=style&index=0&id=00f9e052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports